module.exports = __webpack_public_path__ + "img/ranqi.8eb7c9e5.png";